export const scanQrBtnIconClass = 'fas fa-camera-viewfinder';
